<template>
    <div />
</template>

<script>
export default {
    name: 'stockConfigRedirect',
    created() {
        this.$router.replace({
            path: '/device/device',
            query: {
                ...this.$route.query,
                source: 'stockConfig'
            }
        });
    }
};
</script>
